import React from "react";
import { ChevronDown } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { NAV } from "@/constants/testIds";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem
} from "@/components/ui/dropdown-menu";

const LanguageSwitcher = () => {
  const { lang, setLang, languages } = useApp();
  const current = languages.find((l) => l.code === lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid={NAV.languageSwitcher}
        className="inline-flex items-center gap-1.5 px-3 py-2 border border-border text-xs uppercase tracking-label hover:border-secondary luxe-btn rounded-none"
      >
        <span>{current?.native || "English"}</span>
        <ChevronDown className="w-3 h-3" strokeWidth={1.5} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="max-h-[70vh] overflow-y-auto w-56 rounded-none bg-popover"
        data-testid="language-menu-content"
      >
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`flex justify-between items-center py-2 rounded-none ${
              lang === l.code ? "bg-muted text-primary" : ""
            }`}
          >
            <span className="text-sm">{l.native}</span>
            <span className="text-[10px] uppercase tracking-label text-muted-foreground">{l.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
